import type { HTMLComponent } from "@commercekit/react";
import type { PopularProductsSliceCategoryPage } from "prismicio-types";
import WvProductItem from "~/components/molecules/WvProductItem";
import type { WovarCustomer, WovarProduct } from "@commercekit/api";
import { asText } from "@prismicio/helpers";

const WvPopularProductCategoryPage: HTMLComponent<{
  products: WovarProduct[];
  slice: PopularProductsSliceCategoryPage;
  customer?: WovarCustomer;
}> = ({ products, slice, customer }) => {
  return (
    <div className="component-products mb-5 pb-4">
      <div className="container">
        <h3 className="text-center heading lg underlined pb-3 mb-4">
          {asText(slice?.primary?.title)}
        </h3>
        <div className="popular-products-container">
          {products?.length
            ? products?.map((product) => (
                <WvProductItem
                  className="popular-product-wrapper"
                  key={product.sku}
                  product={product}
                  itemListId="category_popular_product"
                  itemListName="Category Popular Product"
                  customer={customer}
                  showOnlyPriceExclVat={slice?.primary?.show_only_price_excl_vat}
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default WvPopularProductCategoryPage;
